<template>
  <section
    class="promotion-detail"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="">
        <el-form-item >
          <v-radio-group
            v-model="formData.type"
            :list="claimOption"
            @change="handleClearForm"></v-radio-group>
        </el-form-item>
      </div>
      <template  v-if="formData.type==1||formData.type==3">
        <p class="mg-t-20 mg-b-20 fs-14 color-dark">Using claim tickets to handle claim requests</p>
        <div class="flex border-box">
          <div class="half">
            <el-form-item
              ref="cover_image_file_id"
              prop="cover_image_file_id"
            >
              <span>Claim Forms(English)</span>
              <v-upload
                :card="true"
                :fileData="formData.claim_en_form"
                :isBlog="true"
                :otherData="{
                  target: 'claim_en_form',
                  idKey: 'claim_en_form_path_id',
                  nameKey: 'claim_en_form_path'
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div class="half">
            <el-form-item
              ref="claim_zh_form_path_id"
              prop="claim_zh_form_path_id"
            >
              <span>Claim Forms(Chinese)</span>
              <v-upload
                :card="true"
                :fileData="formData.claim_zh_form"
                :isBlog="true"
                :otherData="{
                  target: 'claim_zh_form',
                  idKey: 'claim_zh_form_path_id',
                  nameKey: 'claim_zh_form_path'
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
        </div>
      </template>
      <template  v-if="formData.type==2||formData.type==3">
        <p class="mg-t-20 mg-b-20 fs-14 color-dark">Claim requests are handled by insurer</p>
        <div
          class="flex border-box">
          <div class="half">

            <el-form-item
              ref="title_en"
              :rules='rules.input'
              prop="title_en">
              <span>Title (English)</span>
              <v-input v-model="formData.title_en"></v-input>
            </el-form-item>
            <el-form-item
              ref="body_en"
              :rules='rules.input'
              prop="body_en">
              <span>Post Body (English)</span>
              <v-input
                v-model="formData.body_en"
                type='textarea'
                :rows='5'></v-input>
            </el-form-item>
            <el-form-item
              ref="url_en"
              :rules='rules.input'
              prop="url_en">
              <span>Button URL (English)</span>
              <v-input v-model="formData.url_en"></v-input>
            </el-form-item>
          </div>
          <div class="half">
            <el-form-item
              ref="title_zh"
              :rules='rules.input'
              prop="title_zh">
              <span>Title (Traditional Chinese)</span>
              <v-input v-model="formData.title_zh"></v-input>
            </el-form-item>
            <el-form-item
              ref="body_zh"
              :rules='rules.input'
              prop="body_zh">
              <span>Post Body (Traditional Chinese)</span>
              <v-input
                v-model="formData.body_zh"
                type='textarea'
                :rows='5'></v-input>
            </el-form-item>
            <el-form-item
              ref="url_zh"
              :rules='rules.input'
              prop="url_zh">
              <span>Button URL (Traditional Chinese)</span>
              <v-input v-model="formData.url_zh"></v-input>
            </el-form-item>
          </div>
        </div>
      </template>
    </el-form>
  </section>
</template>

<script>
import { setInsurersClaim,getInsurersClaimDetail } from '@/api/claim'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
export default {
  name: 'changeMethod',
  components:{
  },
  mixins: [MixinRules, MixinOptions],
  props:{
    detailData:{
      type:Object,
      default:()=>({})
    }
  },
  data () {
    return {
      formData: {
        claim_zh_form_path_id: '',
        claim_zh_form_path: '',
        claim_en_form_path_id: '',
        claim_en_form_path: '',
        title_en:'',
        title_zh:'',
        body_en:'',
        body_zh:'',
        url_en:'',
        url_zh:'',
        type:1,
        claim_en_form:null,
        claim_zh_form:null
      },
    }
  },
  computed:{
    company_id(){
      let {company_id} = this.$route.query||{}
      return company_id
    },
    class_id(){
      let {class_id} = this.$route.query||{}
      return class_id
    },
    plan_id(){
      let {plan_id} = this.$route.query||{}
      return plan_id
    },
  },
  watch:{
    detailData:{
      immediate:true,
      handler(val){
        this.formData = Object.assign(this.formData, val)
      }
    }
  },
  methods: {
    handleClearForm(){
      this.$refs.form.clearValidate()
    },
    handlerDeleteFile({otherData}) {
      const { idKey, nameKey, urlKey,target } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, urlKey, '')
      this.$set(this.formData, nameKey, '')
      this.$set(this.formData, target, {})
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, type, index = '',idKey,nameKey } = otherData
      const { id, name, thumb_url, url } = data
      this.$set(this.formData, idKey, id)
      this.$set(this.formData, nameKey, thumb_url)
      this.$set(this.formData, target, data)
    },
    submitForm(){
      this.$refs.form.validate((val, rule) => {
        if(val){
          this.network().setInsurersClaim()
        }else{
          this.scrollToValidDom(rule)
        }
      })
    },
    network(){
      return {
        setInsurersClaim: async (params) => {
          params = {
            ...params,
            company_id:this.company_id,
            class_id:this.class_id,
            plan_id:this.plan_id,
          }
          let {type,claim_en_form_path_id,claim_zh_form_path_id} = this.formData||{}
          if(type==1){
            params = {
              ...params,
              claim_en_form_path_id,
              claim_zh_form_path_id,
              type
            }
          }else {
            params = {
              ...params,
              ...this.formData
            }
          }
          let {data} = await setInsurersClaim(params)
          this.$emit('success')
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.icon{
  color:#409eff;
  cursor: pointer;
}
.clear:after{
  content: ' ';
  display: block;
  height: 0;
  clear: both;
}
.el-form-item{
  padding-bottom: 16px;
  span:first-child{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292E;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
/deep/.upload-card{
  width: 485px;
}
.promotion-detail{
  margin-top: 20px;
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
    margin-right: 10px;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    margin-right: 10px;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .border-box{
    //padding-bottom: 16px;
    //margin-bottom: 31px;
    .half{
      margin-right: 30px;
      width: 485px;
      .classList{
        margin-top: 70px;
      }
      .flex{
        align-items: center;
        .flex-right{
          width: 100%;
          .el-select{
            width: 100%;
          }
        }
        .cb_tips{
          font-style: normal;
          font-family: Inter;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
          margin: 0px 8px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
